export default __webpack_public_path__ + "img/zumperStacked.b80045e0.svg";